import { Modal } from "antd";
import React from "react";
import styled from "styled-components";

import { AlertModalProps } from "../_types";
import ModalFooterLayout from "../ModalFooterLayout";
import useModals from "../../../../hooks/useModals";
import ModalTitle from "../styles/ModalTitle";
import Buttons from "../../../atoms/Buttons";

const AlertModal: React.FC<AlertModalProps> = function TermAlertModal({
  title,
  onOk,
  isDanger,
  okText,
  children,
  contents,
  width,
}) {
  const { closeModal } = useModals();
  return (
    <StyledModal
      width={width}
      onOk={closeModal}
      onCancel={closeModal}
      visible
      title={<ModalTitle>{title}</ModalTitle>}
      centered
      maskClosable={false}
      footer={
        <ModalFooterLayout>
          <Buttons
            type={isDanger ? "warning" : "main"}
            size="large"
            onClick={onOk || closeModal}
            text={okText || "확인"}
          />
        </ModalFooterLayout>
      }
    >
      {children || contents}
    </StyledModal>
  );
};
export default AlertModal;

const StyledModal = styled(Modal)`
  border-radius: 8px;
  div.ant-modal-content {
    border-radius: 8px;
  }
  div.ant-modal-body {
    padding: 8px 24px 0px 24px;
  }
  div.ant-modal-header {
    border: none;

    padding: 24px 24px 0px 24px;
    border-radius: 8px;
  }
  div.ant-modal-title {
    padding: 0px;
  }
  button {
    span.ant-modal-close-x {
      display: none;
    }
  }
  div.ant-modal-footer {
    border-top: none;
    padding: 24px;
  }
`;
